@if (!product().productSplash && product().onSale) {
    <app-product-splash
        class="splash-saving"
        [text]="'productPrices.save' | translateSafe"
        [amount]="product().discountPercentage"
        type="save"
        [size]="compressed() ? 'm' : 'm'"
    >
    </app-product-splash>
}

@if (product().activeSplashes | activeSplash: 'RetailMedia' | async; as splash) {
    <app-product-splash
        class="splash-retail-media"
        [text]="splash.splashDescription"
        [type]="'retail-media'"
        [style]="{
                    backgroundColor: splash.ribbonColor | colorStringToHex
                }"
        size="s"
    ></app-product-splash>
}

@switch ((product().activeSplashes | getPrioritySplash)?.type) {
    @case ('CampaignSplash1') {
        <app-product-splash
            *ngIf="displayCampaigns() && product().productSplash"
            class="splash-statement"
            [text]="product().productSplash?.text"
            [type]="type()"
            [style]="{
                backgroundColor: '437e89' | colorStringToHex
            }"
        ></app-product-splash>
    }
    @default {
        @if (({ activeCampaigns: product().activeCampaigns, activeSplashes: product().activeSplashes }
            | firstSplash: ['RetailMedia']
            | async); as splash) {

            <app-product-splash
                class="splash-statement"
                [text]="splash.splashDescription"
                [type]="type()"
                [style]="{
                        backgroundColor: splash.ribbonColor | colorStringToHex
                    }"
            ></app-product-splash>
        }
    }
}

@if (product().hasBurdDelivery | sameDayDelivery | async; as splash) {
    <app-product-splash
        class="splash-statement"
        [text]="splash.splashDescription"
        [type]="type()"
        [style]="{
            backgroundColor: splash.ribbonColor | colorStringToHex
        }"
    ></app-product-splash>
}
